import { faBan } from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import { useTranslation } from "react-i18next";

import ExternalStateMessage from "./ExternalStateMessage";

const InviteNotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ExternalStateMessage
      icon={faBan}
      title={t("external_invite.not_found.title")}
      description={t("external_invite.not_found.description")}
      dataCy="externalInviteNotFound"
    />
  );
};

export default InviteNotFound;
